<template>
  <detail-form :by-assets="true" @dataUpdate="dataUpdate" :assets-list="assetsList" :typeList="typeList" :budget-detail-list="budgetDetailList" :orgList="orgList" ref="dForm" :data="chooseData"></detail-form>
</template>

<script>
import detailForm from '../../repair/apply/fromAndSubmit'

import {
  budgetDetailRequest
} from '../../../api'

export default {
  components: {
    detailForm
  },
  data () {
    return {
      typeList: [{key: 'mini', label: '价值2000元以下'}, {key: 'norm', label: '价值2000元以上'}],
      chooseData: null,
      budgetDetailList: [],
      assetsList: []
    }
  },
  created () {
    this.$store.dispatch('loadOrgList')
    this.loadBudgetDetailList()
  },
  computed: {
    orgList () {
      let allData = this.$store.getters.orgList
      let myOrgIds = this.$store.getters.currentOrgId ? [this.$store.getters.currentOrgId] : []
      return allData.filter(v => myOrgIds.length === 0 ||  myOrgIds.includes(v.key))
    }
  },
  methods: {
    async loadBudgetDetailList () {
      let datas = await budgetDetailRequest.get({
        status: 'final_pass',
        year: new Date().getFullYear()
      })
      this.budgetDetailList = datas
    },
    async dataUpdate () {
      this.$notify({
        title: '系统提示',
        message: '维修申请添加成功',
        type: 'success'
      })
    },
    add (assets) {
      if (!assets || !assets.id) {
        this.$notify({
          title: '系统提示',
          message: '数据异常',
          type: 'error'
        })
        return
      }
      this.assetsList = [assets]
      this.chooseData = {
        jz: assets.jz,
        detailList: [{
          assetsId: assets.id,
          jz: assets.jz,
          assets: assets
        }]
      }
      this.$refs.dForm.modal = true
    }
  }
}
</script>

<style scoped lang="less">
.apply-page {
  background: #fff;
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  margin: 10px;
  .title-sort {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .p-d-c {
    width: calc(100% - 40px);
    height: calc(100% - 88px);
  }
  .p-d-s {
    width: 100%;
    height: calc(100% - 48px);
  }
  .p-d-s-n {
    width: 100%;
    height: calc(100% - 48px);
    font-size: 20px;
    color: #515a6e;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      padding: 20px;
    }
  }
  .left {
    height: calc(100% - 20px);
    overflow-y: auto;
    width: 300px;
    border-right: 1px solid #e8eaec;;
    padding-right: 20px;
  }
  .right {
    height: calc(100% - 20px);
    flex: 1;
    overflow-y: auto;
    border-top: 1px solid #e8eaec;;
    border-right: 1px solid #e8eaec;;
    border-bottom: 1px solid #e8eaec;;
    .right-btns {
      padding:10px 20px;
      display: flex;
      justify-content: space-around;
    }
  }
  .sign-item {
    margin-bottom: 10px;
  }
}
</style>